export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex flex-wrap items-center justify-center lg:justify-start gap-1.5 text-xs md:text-sm text-primary-600 font-medium mb-4">
              <span className="px-2.5 py-1 bg-primary-100/70 rounded-full whitespace-nowrap">6080影院</span>
              <span className="px-2.5 py-1 bg-primary-100/70 rounded-full whitespace-nowrap">小a影院</span>
              <span className="px-2.5 py-1 bg-primary-100/70 rounded-full whitespace-nowrap">8090影院</span>
              <span className="px-2.5 py-1 bg-primary-100/70 rounded-full whitespace-nowrap">4480影院</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              51影院 - 免费高清影视在线观看平台
            </h1>

            <p className="text-base md:text-lg text-accent-600 font-medium mb-5">
              超清画质 · 免广告 · 不缓冲 · 流畅体验
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              汇聚6080影院、小a影院、8090影院、4480影院等全网优质影视资源，涵盖最新电影、热播剧集、热门综艺、经典动漫等全类型内容。每日同步更新，无需注册登录，打开即看，真正实现超清画质流畅播放，全程无广告打扰，为你打造纯净舒适的在线观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading font-bold text-primary-500">20000+</div>
                <div className="text-xs text-foreground-500 mt-0.5">影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-0.5">同步院线</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading font-bold text-primary-500">超清画质</div>
                <div className="text-xs text-foreground-500 mt-0.5">免广告流畅</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-full transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                立即观影
              </a>
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-800 font-semibold text-sm rounded-full transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                查看推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20atmosphere%20with%20soft%20amber%20lighting%2C%20film%20reel%20and%20projector%20glow%2C%20vintage%20cinema%20aesthetic%20with%20red%20velvet%20curtains%2C%20warm%20golden%20tones%2C%20artistic%20photography%20style%2C%20dreamy%20bokeh%20background%2C%20elegant%20composition&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="51影院 - 免费高清影视在线观看平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}